import { withParams, req, len } from 'vuelidate/lib/validators/common'
import { email as _email } from 'vuelidate/lib/validators'

const required = message => withParams({message: message}, req)
const email = message => withParams({message: message}, _email)
const minLength = (length, message) => withParams({message: message, min: length}, value => !req(value) || len(value) >= length)
const json = message => withParams({message: message}, value => {
	try {
		JSON.parse(value)
		return true
	} catch (e) {
		return false
	}
})

export {
	required,
	email,
	minLength,
	json
}
